export default __webpack_public_path__ + "static/media/W51Bed.1f9160fb.jpg";